function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Field } from 'redux-form';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
import { getDataTestAttribute } from '../../../helpers/dataTestAttributeHelper';
var baseClass = 'ap-input';
var InnerInput = function InnerInput(props, context) {
  var input = props.input,
    customClass = props.customClass,
    classModifiers = props.classModifiers,
    meta = props.meta,
    rows = props.rows,
    info = props.info,
    label = props.label,
    labelInInput = props.labelInInput,
    rightLabelText = props.rightLabelText,
    iconComponent = props.iconComponent,
    passedProps = _objectWithoutProperties(props, ['input', 'customClass', 'classModifiers', 'meta', 'rows', 'info', 'label', 'labelInInput', 'rightLabelText', 'iconComponent']);
  var isTextArea = rows > 1;
  var bemClasses = getBEMClasses([baseClass, customClass]);
  var inputProps = Object.assign({
    className: classnames('form-control', _defineProperty({}, bemClasses('with-label'), labelInInput), _defineProperty({}, bemClasses('input', 'error', ''), meta.dirty && meta.error), _defineProperty({}, bemClasses('text-area'), isTextArea), rightLabelText ? bemClasses('input', 'with-right-label') : bemClasses('input', classModifiers))
  }, input, passedProps);
  return React.createElement('div', {
    className: 'form-group ' + bemClasses('input-wrapper', classModifiers)
  }, props.type !== 'hidden' && React.createElement('label', {
    className: 'ap--label ' + bemClasses('label', classModifiers)
  }, label), React.createElement('div', {
    className: classnames(rightLabelText && bemClasses('input-with-right-label-container'), bemClasses('input-box'))
  }, labelInInput && React.createElement('span', {
    className: 'label-in-input ' + bemClasses('label-in-input')
  }, labelInInput), isTextArea ? React.createElement('textarea', Object.assign({}, inputProps, {
    'data-test': getDataTestAttribute(props, 'label')
  })) : !iconComponent ? React.createElement('input', Object.assign({
    'data-test': getDataTestAttribute(props, 'label')
  }, inputProps)) : React.createElement('div', {
    className: bemClasses('input-with-icon')
  }, React.createElement('input', Object.assign({
    'data-test': getDataTestAttribute(props, 'label')
  }, inputProps)), iconComponent), rightLabelText ? React.createElement('div', {
    className: bemClasses('right-label')
  }, React.createElement('span', {
    className: bemClasses('right-label-span')
  }, rightLabelText)) : null, info && React.createElement('div', {
    className: 'form-text-muted ' + bemClasses('info')
  }, info), meta.touched && meta.error && React.createElement('div', {
    className: bemClasses('error')
  }, context.t(meta.error))));
};
export { InnerInput };
InnerInput.contextTypes = {
  t: PropTypes.func.isRequired
};
var APInput = function APInput(props) {
  return React.createElement(Field, Object.assign({
    name: props.name,
    component: InnerInput
  }, props));
};
APInput.defaultProps = {
  name: '',
  label: '',
  labelInInput: '',
  type: '',
  classModifiers: '',
  placeholder: '',
  info: '',
  autoFocus: '',
  disabled: false,
  required: false,
  rows: 1
};
APInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  labelInInput: PropTypes.string,
  type: PropTypes.string,
  customClass: PropTypes.string,
  classModifiers: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  placeholder: PropTypes.string,
  info: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  autoFocus: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  rightLabelText: PropTypes.string,
  rows: PropTypes.number,
  dataTest: PropTypes.string
};
APInput.contextTypes = {
  t: PropTypes.func.isRequired
};
export default APInput;